/* kk-ga-ids.js: carry the buyer's GA4 client id + session id onto the order, so a purchase that never reaches the
   thank-you page (gateway redirect) can be sent to GA4 later with the right attribution.
   1. hidden line-item properties properties[_ga_cid] / properties[_ga_sid] in every /cart/add form
   2. cart attributes _ga_cid / _ga_sid when the cart already has items
   Underscore keys are hidden from the customer. Never throws. Works with any GA4 property: it reads the first
   _ga_<ID> session cookie it finds. */
(function () {
  "use strict";
  function cookie(name) {
    var parts = document.cookie.split("; ");
    for (var i = 0; i < parts.length; i++) {
      var kv = parts[i].split("=");
      if (kv[0] === name) return decodeURIComponent(kv.slice(1).join("="));
    }
    return "";
  }
  function sessionCookie() {
    var parts = document.cookie.split("; ");
    for (var i = 0; i < parts.length; i++) {
      var k = parts[i].split("=")[0];
      if (k.indexOf("_ga_") === 0) return decodeURIComponent(parts[i].slice(k.length + 1));
    }
    return "";
  }
  function ids() {
    var cid = "", sid = "";
    var p = cookie("_ga").split(".");
    if (p.length >= 4) cid = p[p.length - 2] + "." + p[p.length - 1];
    var gs = sessionCookie();
    var m = gs.match(/^GS2\.\d+\.s(\d+)/);
    if (m) sid = m[1];
    else {
      var q = gs.split(".");
      if (q.length >= 3 && /^\d+$/.test(q[2])) sid = q[2];
    }
    return { cid: cid, sid: sid };
  }
  function stamp(form) {
    try {
      var v = ids();
      if (!v.cid) return;
      [["_ga_cid", v.cid], ["_ga_sid", v.sid]].forEach(function (kv) {
        if (!kv[1]) return;
        var name = "properties[" + kv[0] + "]";
        var el = form.querySelector('input[name="' + name + '"]');
        if (!el) { el = document.createElement("input"); el.type = "hidden"; el.name = name; form.appendChild(el); }
        el.value = kv[1];
      });
    } catch (e) {}
  }
  function stampAll() {
    try {
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) stamp(forms[i]);
    } catch (e) {}
  }
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (f && f.action && String(f.action).indexOf("/cart/add") !== -1) stamp(f);
  }, true);
  document.addEventListener("pointerdown", function (e) {
    var t = e.target;
    var f = t && t.closest && t.closest('form[action*="/cart/add"]');
    if (f) stamp(f);
  }, true);
  function syncCart() {
    try {
      var v = ids();
      if (!v.cid || !window.fetch) return;
      fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (c) {
        if (!c || !c.item_count) return;
        var a = c.attributes || {};
        if (a._ga_cid === v.cid && a._ga_sid === v.sid) return;
        fetch("/cart/update.js", {
          method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes: { _ga_cid: v.cid, _ga_sid: v.sid } })
        }).catch(function () {});
      }).catch(function () {});
    } catch (e) {}
  }
  function start() { stampAll(); setTimeout(stampAll, 2500); setTimeout(syncCart, 3000); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
